import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchAttribute } from "../services/AttributeService";
import { Attribute } from "../Types/Attribute";

export interface LoadAttributePayload {
    elementGuid: string;
    attributeGuid: string;
    hoursStarting: number;
}

interface AttributesState {
    attributes: Attribute[];
}

const initialState: AttributesState = {
    attributes: []
};

const loadAttributes = createAsyncThunk(
    "attributes/getAttribute",
    async (payload: LoadAttributePayload) => {
        const attributes = await fetchAttribute(payload);
        return attributes;
    }
);

const attributesSlice = createSlice({
    name: "attributes",
    initialState,
    reducers: {
        addAttributes: (state, action: PayloadAction<Attribute[]>) => {
            if (Array.isArray(action.payload)) {
                state.attributes.push(...action.payload);
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loadAttributes.fulfilled, (state, action) => {
            const payload: unknown = action.payload;
            if (Array.isArray(payload)) {
                state.attributes.push(...(payload as Attribute[]));
            } else if (payload && typeof payload === "object") {
                // API may return a single attribute instead of an array
                state.attributes.push(payload as Attribute);
            }
        });
    }
});

export default attributesSlice.reducer;
export const { addAttributes } = attributesSlice.actions;
export { loadAttributes };
